import { render, staticRenderFns } from "./AddDialog.vue?vue&type=template&id=bcd4d720&scoped=true"
import script from "./AddDialog.vue?vue&type=script&lang=js"
export * from "./AddDialog.vue?vue&type=script&lang=js"
import style0 from "./AddDialog.vue?vue&type=style&index=0&id=bcd4d720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd4d720",
  null
  
)

export default component.exports